// "Now" for the date tabs (Today, Last/This/Next Week) and the All Tasks sort, in India time (IST),
// taken from the server's clock rather than this computer's clock (CR-15).
// If the server cannot be reached, this computer's clock is used, still converted to IST.
import { startOfWeek, endOfWeek } from 'date-fns';

let skewMs = 0; // server clock minus this computer's clock

try {
  const sent = Date.now();
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/server-time`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data || typeof data.epochMs !== 'number') return;
      const received = Date.now();
      skewMs = data.epochMs + (received - sent) / 2 - received;
    })
    .catch(() => {});
} catch (e) {
  // keep this computer's clock
}

// A Date whose year, month, day and time read as the current IST time, on a computer in any time zone.
export const istNow = () => {
  const ms = Date.now() + skewMs;
  return new Date(ms + (new Date(ms).getTimezoneOffset() + 330) * 60000);
};

const pad = (n) => String(n).padStart(2, '0');

// Today's date in IST as "yyyy-MM-dd".
export const istTodayKey = () => {
  const d = istNow();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// True when the date falls in this week, Monday 00:00:00 to Sunday 23:59:59, in IST.
export const isThisWeekIST = (date) => {
  const n = istNow();
  return date >= startOfWeek(n, { weekStartsOn: 1 }) && date <= endOfWeek(n, { weekStartsOn: 1 });
};
